module.exports = __webpack_public_path__ + "static/media/product1.a822620f.webp";